import { gql } from "generated-graphql";

export const UNIFIED_WORK_QUERY = gql(`
  query UnifiedWorkItems($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    unifiedWorkItems(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        workflowId
        activityId
        workTypeKey
        workTypeLabel
        academyArticleUrl
        subjectType
        title
        activityType
        activityDescription
        activityStatus
        workflowStatus
        dueAt
        dueType
        estimateMinutes
        assigneeEmail
        assigneeId
        assigneeReadOnly
        tenantId
        tenantName
        facilityName
        state
        reportingYear
        tierIIReportId
        cohortId
        submissionId
        processedManifestId
        manifestTrackingNumber
        generatorStatusExceedanceId
        exceedanceFacilityId
        exceedanceSource
        exceedancePeriodStart
        credentialImplementationId
        harmonizedViolationId
        harmonizedViolationKey
        tags
        createdAt
      }
      count
    }
  }
`);

export const UPDATE_WORKFLOW_ESTIMATES_MUTATION = gql(`
  mutation UpdateWorkflowEstimates($workflowIds: [ID!]!, $estimateMinutes: Int) {
    updateWorkflowEstimates(workflowIds: $workflowIds, estimateMinutes: $estimateMinutes)
  }
`);

export const UNIFIED_WORK_STATS_QUERY = gql(`
  query UnifiedWorkStats($search: String) {
    unifiedWorkStats(search: $search) {
      total
      assigned
      unassigned
      byWorkType {
        workTypeKey
        workTypeLabel
        count
        assigned
      }
    }
  }
`);
